import React, { useState, useEffect, memo, useCallback, useContext, useRef } from "react";
import { callApi, isEmpty, addZero } from "bodycodi/cmap/app/js/common";
import Drawer from "@material-ui/core/Drawer";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";
import LoadingSpinner from "bodycodi/cmap/app/components/common/loadingSpinner";

type ChooseAppointmentTimeProp = {
  fromMngt: boolean;
  setTime: Function;
  setStep: Function;
  chooseDate: any;
  pass: any;
  children: any;
};

type trainerSchdule = {
  morningSchedule: Array<any>;
  afternoonSchedule: Array<any>;
  eveningSchedule: Array<any>;
};

const ChooseAppointmentTimeWrap = (prop: ChooseAppointmentTimeProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = useCallback(() => {
    if (prop.fromMngt) {
      dispatch({ type: "POP_UP_OPEN", id: "CHOOSE_DATE_POP", open: { chooseDatePop: false } });
      dispatch({
        type: "POP_UP_OPEN",
        id: "CHOOSE_APPOINTMENT_TIME_POP",
        open: { chooseAppointmentTimePop: false },
      });
      return;
    }
    dispatch({ type: "CLOSE_ALL_POP" });
  }, [prop.fromMngt]);

  return (
    <>
      <Drawer
        anchor="bottom"
        open={state.chooseAppointmentTimePop}
        onClose={handleClose}
        className="picker-pop max"
      >
        <PickerHeader title="개인레슨 스케줄 예약" onClose={handleClose} />
        {state.chooseAppointmentTimePop && <ChooseAppointmentTime {...prop} />}
      </Drawer>
    </>
  );
};

const ChooseAppointmentTime = ({
  setTime,
  setStep,
  chooseDate,
  pass,
  children,
}: ChooseAppointmentTimeProp) => {
  const { seqPartner, seqPartnerBranch, seqPartnerCoach } = useSelector(
    (state: RootState) => state.partner
  );
  const pop = useRef<HTMLDivElement>(null);
  const [trainerSchdule, setTrainerSchedule] = useState<trainerSchdule>({
    morningSchedule: [],
    afternoonSchedule: [],
    eveningSchedule: [],
  });
  const [isLoadingDone, setIsLoadingDone] = useState<boolean>(false);

  useEffect(() => {
    if (isEmpty(pass)) {
      return;
    }

    callApi(
      "/schedule/reservation/view-time",
      {
        searchDate: `${chooseDate.year}-${addZero(chooseDate.month)}-${addZero(chooseDate.date)}`,
        seqPartnerCoach: seqPartnerCoach,
        seqPassInfo: pass.seqPassInfo,
        seqPartner: seqPartner,
        seqPartnerBranch: seqPartnerBranch,
      },
      "POST"
    )
      .then((res) => {
        const morningList = [];
        const afternoonList = [];
        const eveningList = [];
        const scheduleList = res.reservationTimeList;
        if (!isEmpty(scheduleList)) {
          if (scheduleList.length != 0) {
            for (let i = 0; i < scheduleList.length; i++) {
              const schedule = scheduleList[i];
              const scheduleTime = parseInt(schedule.reservationStartTime.slice(0, 2), 10);
              if (scheduleTime < 12) {
                morningList.push(schedule);
              } else if (scheduleTime >= 12 && scheduleTime < 18) {
                afternoonList.push(schedule);
              } else {
                eveningList.push(schedule);
              }
            }
            setTrainerSchedule({
              morningSchedule: morningList,
              afternoonSchedule: afternoonList,
              eveningSchedule: eveningList,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setIsLoadingDone(true);
      });
  }, [pass, chooseDate]);

  const clickTime = (d: any) => (e: any) => {
    if (d.timePossibleYn === "N") {
      return;
    }
    const timeList = pop.current!.querySelectorAll(".time");
    for (let i = 0; i < timeList.length; i++) {
      const time = timeList[i] as HTMLDivElement;
      time.classList.remove("active");
    }
    e.currentTarget.classList.add("active");

    const rvEndSec =
      parseInt(d.reservationStartTime.slice(0, 2), 10) * 60 +
      parseInt(d.reservationStartTime.slice(3, 5), 10) +
      pass.serviceTime;
    const rvEndMin = rvEndSec % 60;
    const rvEndHour = (rvEndSec - rvEndMin) / 60;
    setTime({
      reservationStartTime: d.reservationStartTime,
      reservationEndTime: `${addZero(rvEndHour)}:${addZero(rvEndMin)}`,
    });
  };

  const morningScheduleList = trainerSchdule.morningSchedule.map((d: any) => {
    return (
      <div
        className={"time" + (d.timePossibleYn === "N" ? " disable" : "")}
        onClick={clickTime(d)}
        key={d.reservationStartTime}
      >
        {d.reservationStartTime}
      </div>
    );
  });

  const eveningScheduleList = trainerSchdule.eveningSchedule.map((d: any) => {
    return (
      <div
        className={"time" + (d.timePossibleYn === "N" ? " disable" : "")}
        onClick={clickTime(d)}
        key={d.reservationStartTime}
      >
        {d.reservationStartTime}
      </div>
    );
  });

  const afternoonScheduleList = trainerSchdule.afternoonSchedule.map((d: any) => {
    return (
      <div
        className={"time" + (d.timePossibleYn === "N" ? " disable" : "")}
        onClick={clickTime(d)}
        key={d.reservationStartTime}
      >
        {d.reservationStartTime}
      </div>
    );
  });

  return (
    <div className="picker-body choose-schedule-time-pop add-schedule-pop-wrap" ref={pop}>
      <div className="add-schedule-pop">
        <div className="title">시간 선택</div>
        {!isLoadingDone && (
          <div className="empty-box">
            <LoadingSpinner />
          </div>
        )}
        {trainerSchdule.morningSchedule.length === 0 &&
          trainerSchdule.afternoonSchedule.length === 0 &&
          trainerSchdule.eveningSchedule.length === 0 &&
          isLoadingDone && (
            <div className="empty-box">
              <div className="empty-title">가능한 시간이 없어요.</div>
              <div className="empty-desc">다른 날짜를 선택해주세요.</div>
            </div>
          )}
        {trainerSchdule.morningSchedule.length !== 0 && (
          <>
            <div className="sub-title">오전</div>
            <div className="time-list">{morningScheduleList}</div>
          </>
        )}
        {trainerSchdule.afternoonSchedule.length !== 0 && (
          <>
            <div className="sub-title">오후</div>
            <div className="time-list">{afternoonScheduleList}</div>
          </>
        )}
        {trainerSchdule.eveningSchedule.length !== 0 && (
          <>
            <div className="sub-title">저녁</div>
            <div className="time-list">{eveningScheduleList}</div>
          </>
        )}
      </div>
      {children}
    </div>
  );
};

export default memo(ChooseAppointmentTimeWrap);
